import api from './api';

/**
 * Identity Service
 * Handles all identity-related API calls
 */
const identityService = {
  /**
   * Build query string from filter object
   * @param {Object} filters - Filter parameters
   * @returns {string} Query string
   */
  _buildQueryString(filters = {}) {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.search) params.append('search', filters.search);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
    if (filters.account) params.append('account', filters.account)

    if (filters.type) {
      const types = Array.isArray(filters.type) ? filters.type.join(',') : filters.type;
      params.append('type', types);
    }

    if (filters.status) {
      const statuses = Array.isArray(filters.status) ? filters.status.join(',') : filters.status;
      params.append('status', statuses);
    }

    if (filters.riskLevel) {
      const levels = Array.isArray(filters.riskLevel) ? filters.riskLevel.join(',') : filters.riskLevel;
      params.append('riskLevel', levels);
    }

    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
  },

  /**
   * Get all identities with optional filters
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllIdentities(filters = {}) {
    const queryString = this._buildQueryString(filters);
    const response = await api.get(`/identities${queryString}`);
    // console.log("identities",response.data);

    return response.data;
  },



  async getStats() {
    const response = await api.get('/risk/overview');
    // console.log("getstats",response);
    return response.data;
  },

  /**
   * Get API health status
   * @returns {Promise} API response
   */
  async getHealth() {
    const response = await api.get('/health');
    // console.log("health",response);
    return response;
  },

  async getSelectedIdentityAttackVectors(identityId) {
    const response = await api.get(`/identity-attack-vectors/${identityId}`);
    // console.log("selected identity attack-vectors",response);
    return response?.data;
  },

  async getMfaDistribution(filters = {}) {
    try {
      const queryString = this._buildQueryString(filters);
      const response = await api.get(`/mfa-distribution${queryString}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
      };
    }
  },

  async getMfaMethodUsers(method, filters = {}) {
    try {
      const queryString = this._buildQueryString(filters);

      const response = await api.get(
        `/mfa-method-users/${method}${queryString}`
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
      };
    }
  },

  async getIdentityDarkwebDetails() {
    try {
      const response = await api.get('/dark-web', {
      });
      // console.log("get darkweb identity",response)
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
      };
    }
  }

};

export default identityService;